import React from 'react';
import cx from 'classnames';
import Copy, {CopyProps} from '../../../components/common/Copy';
import {Icon} from 'epic-diesel-common';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    disabled: {},
    root: {
        display: 'inline-block',

        '&:not($disabled)': {
            cursor: 'pointer',
            '& $icon': {
                transition: 'opacity 0.3s',
                '&:hover': {
                    transition: 'opacity 0.3s',
                    opacity: 1
                }
            }
        },

        '&$disabled': {
            '& $icon': {
                cursor: 'unset'
            }
        }
    },
    icon: {
        opacity: 0.2,
        '& svg': {
            transform: 'rotate(-45deg)',
            marginTop: '2px'
        }
    }
}));

export interface CopyReferralProps extends Omit<CopyProps, 'text' | 'children'> {
    link: string;
    enableLink?: boolean;
    copyReferralLink?: string;
    copyReferralLinkSuccess?: string;
    copyReferralLinkFailed?: string;
}

export const CopyReferral: React.FC<CopyReferralProps> = ({
    link,
    enableLink = true,
    copyReferralLink = 'Copy Referral Link',
    copyReferralLinkSuccess = 'Referral Link Copied!',
    copyReferralLinkFailed = 'Failed to Access Clipboard',
    ...copyProps
}) => {
    const styles = useStyles();
    const disableCopy = !link || !enableLink;
    const rootClasses = cx(styles.root, {
        [styles.disabled]: disableCopy
    });

    return (
        <Copy
            {...copyProps}
            className={rootClasses}
            text={link}
            tip={copyReferralLink}
            successTip={copyReferralLinkSuccess}
            errorTip={copyReferralLinkFailed}
            disabled={disableCopy}>
            <Icon className={styles.icon} icon="LINK" />
        </Copy>
    );
};

export default CopyReferral;
